import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDatabase } from '../hooks/useDatabase';
import { usePublicLanding } from '../hooks/usePublicContent';
import { ThankYouView } from '../components/public/ThankYouView';
import { readSubmission } from '../utils/postSubmit';
import { resolveMetaPixel } from '../utils/metaPixel';
import { useMetaPixelPageView } from '../hooks/useMetaPixel';
import { normalizePublicSlug } from '../config/app';
import { DEFAULT_THANK_YOU } from '../data/thankYou';

/** Página de agradecimiento configurable por landing: /gracias/:slug */
export function ThankYou() {
  const {
    slug: rawSlug = ''
  } = useParams();
  // Mismo saneado que en la landing pública: espacios, %20, barras y mayúsculas.
  const slug = normalizePublicSlug(rawSlug);
  const db = useDatabase();
  usePublicLanding(slug);
  const landing = db.landings.find(l => l.slug === slug);
  const organization = landing ? db.organizations.find(o => o.id === landing.organizationId) : undefined;
  const logoUrl = landing?.pageConfig.logoUrl ?? organization?.brand.logoUrl ?? organization?.logoUrl;
  const config = landing?.pageConfig.thankYou ?? DEFAULT_THANK_YOU;
  /*
   * Envío de ESTE visitante, guardado en sessionStorage al enviar el
   * formulario. Se lee una sola vez y nunca se consulta «el último lead», así
   * que dos visitantes simultáneos no pueden ver los datos del otro.
   */
  const submission = React.useMemo(() => readSubmission(slug), [slug]);

  // A. La página de gracias es una página real dentro de la misma SPA: se
  // cuenta como su propia visita. El Lead ya se disparó al confirmarse el
  // envío en la landing (ver LandingView), así que aquí NUNCA se repite.
  const metaPixel = resolveMetaPixel(landing?.pageConfig.metaPixel);
  useMetaPixelPageView(metaPixel);
  useEffect(() => {
    if (!config.autoRedirectUrl) return;
    const timer = setTimeout(() => {
      window.location.href = config.autoRedirectUrl as string;
    }, 4000);
    return () => clearTimeout(timer);
  }, [config.autoRedirectUrl]);
  return <ThankYouView config={config} submission={submission} logoUrl={logoUrl} primaryColor={landing?.pageConfig.primaryColor} fallbackPhone={landing?.pageConfig.floating?.whatsapp?.phone} metaPixel={metaPixel} data-id="element-2131" data-mp="130z3uecxre5r" />;
}